import axios from 'crypto-fetch/axios.js'
import xfetch from '@ms/fetch'

/**
 * get user balance
 * @returns {Number} 用户可用余额
 */
export const fetchBalance = async () => {
  const data = await axios.get('/pocket/financialAccounts/balance')
  return data.avlBal
}

/**
 * update user info
 * @param  {Object} body user info
 * @return {Promise} [description]
 */
export const updateUserInfo = (body = {}) => axios.put('/patron/account/info/whole', body)

/**
 * 生成邮件验证链接并发送
 * @return {Promise} [description]
 */
export const sendVerifyEmail = (mail = '') => axios.put('/patron/mail/verify/send', { mail })

/**
 * 获取用户提现密码相关信息
 * @param  {Number} emailMaskFlag 邮箱是否掩码标识 1-不掩码
 */
export const fetchWithdrawSecurityInfo = async (emailMaskFlag = 0) => {
  const params = {}
  if (emailMaskFlag) {
    Object.assign(params, { emailMaskFlag })
  }
  return axios.get('/patron/security/search_withdraw_security_info', { params })
}

/**
 * 安全邮箱：提交用户材料
 * @param  {Object} body 用户材料
 */
export const postUserMaterials = (body = {}) => axios.post('/pocket/material/submit', body)

/**
 * 判断当前ip是否需要 cloudflare 验证码
 */
export const checkUserIPVeryfiStatus = (phone = '') => {
  const params = new URLSearchParams({})
  if (phone) {
    params.append('phone', phone)
  }
  return xfetch(`/patron/verify-code/status?${params}`)
}
